import snakeCase from 'lodash/snakeCase';
import type { IEventBridgeAdapter, ApiEvent } from './types';

const EVENT_CATEGORY = 'apiEvent';

export class ApiEventAdapter implements IEventBridgeAdapter<ApiEvent> {
	formatEvent = (e: ApiEvent) => {
		const originalEvent: typeof e = {
			type: `api.${snakeCase(e.type)}`,
			details: e.details,
		};
		return {
			category: EVENT_CATEGORY,
			originalEvent,
			timestamp: new Date().toISOString(),
		};
	};
}
